import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "tab-select",
  "data-tabs": ""
}
const _hoisted_2 = { class: "tab-select__list-cont" }
const _hoisted_3 = {
  class: "tab-select__list",
  role: "tablist"
}
const _hoisted_4 = ["data-active"]
const _hoisted_5 = { class: "tab-select__culture" }
const _hoisted_6 = ["data-active"]
const _hoisted_7 = { class: "tab-select__culture" }
const _hoisted_8 = {
  key: 0,
  class: "p-b-x10"
}
const _hoisted_9 = { class: "context-err" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", { class: "context-err__icon" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#svg-warning" })
], -1 /* HOISTED */)

import { ref, onMounted, onUnmounted, inject } from 'vue'
import {
  getStoredTerminal,
  setStoredTerminal,
} from './../utilities/terminal-storage-helper'
import { AppSettingsKey } from './../types/keys'
import type {
  AppSettings,
  TravelInfoSettings,
  TravelInfoTerminals,
} from './../types'
import { Terminal } from './../types/enums'
import TravelInfoService from './../services/travel-info-service'
import { handleLoadingState } from './../utilities/async-helper'
import TravelInfo from './travel-info/TravelInfo.vue'
import StatusAlert from './travel-info/StatusAlert.vue'
import DeparturesBoard from './departures/DeparturesBoard.vue'
import LoadingWrapper from './shared/LoadingWrapper.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TravelUpdates',
  setup(__props) {

let travelInfoRefreshInterval: number
let travelInfoSettings = ref<TravelInfoSettings>()
let travelInfoTerminals = ref<TravelInfoTerminals | null>()

const appSettings = inject(AppSettingsKey) as AppSettings
const travelInfoService = new TravelInfoService(appSettings.apiBaseUrl)
const activeTerminal = ref<Terminal>(Terminal.Uk)
const errorState = ref<boolean>(false)
const loadingState = ref<boolean>(true)
const mounted = ref<boolean>(false)

async function fetchTravelInfo(): Promise<void> {
  await handleLoadingState(loadingState, errorState, async () => {
    const travelInfoResponse = await travelInfoService.GetTravelInfo()
    travelInfoSettings.value = travelInfoResponse.settings
    travelInfoTerminals.value = travelInfoResponse.terminals
    errorState.value = false
  })
}

function setActiveTerminal(terminal: Terminal): void {
  activeTerminal.value = terminal
  setStoredTerminal(terminal)
}

onMounted(async () => {
  await fetchTravelInfo()
  mounted.value = true
  activeTerminal.value = getStoredTerminal(
    appSettings?.defaultTerminal || Terminal.Uk
  )

  // Refresh travel info
  travelInfoRefreshInterval = window.setInterval(async () => {
    await fetchTravelInfo()
  }, (travelInfoSettings.value?.refreshRateSeconds || 30) * 1000)
})

onUnmounted(() => {
  clearInterval(travelInfoRefreshInterval)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "tab-select__link",
          role: "tab",
          "data-active": activeTerminal.value == _unref(Terminal).Uk,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (setActiveTerminal(_unref(Terminal).Uk)))
        }, [
          _createTextVNode(_toDisplayString(_unref(appSettings).terminalNameFolkestone) + " ", 1 /* TEXT */),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(appSettings).resourceStrings['TravelUpdates.Labels.UK']), 1 /* TEXT */)
        ], 8 /* PROPS */, _hoisted_4),
        _createElementVNode("button", {
          class: "tab-select__link",
          role: "tab",
          "data-active": activeTerminal.value == _unref(Terminal).Fr,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (setActiveTerminal(_unref(Terminal).Fr)))
        }, [
          _createTextVNode(_toDisplayString(_unref(appSettings).terminalNameCalais) + " ", 1 /* TEXT */),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(appSettings).resourceStrings['TravelUpdates.Labels.FR']), 1 /* TEXT */)
        ], 8 /* PROPS */, _hoisted_6)
      ])
    ]),
    (errorState.value && !_unref(travelInfoTerminals))
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createTextVNode(" " + _toDisplayString(_unref(appSettings).resourceStrings[
            'TravelUpdates.TravelInfo.ApiErrorMessage'
          ]), 1 /* TEXT */)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(LoadingWrapper, {
        loading: !mounted.value
      }, {
        default: _withCtx(() => [
          (_unref(travelInfoSettings)?.statusAlerts?.isVisible)
            ? (_openBlock(), _createBlock(StatusAlert, {
                key: 0,
                "status-alert": _unref(travelInfoSettings).statusAlerts.folkestone
              }, null, 8 /* PROPS */, ["status-alert"]))
            : _createCommentVNode("v-if", true),
          (
            _unref(travelInfoTerminals) && _unref(travelInfoSettings)?.latestInfo?.isVisible
          )
            ? (_openBlock(), _createBlock(TravelInfo, {
                key: 1,
                settings: _unref(travelInfoSettings),
                "terminal-data": _unref(travelInfoTerminals).folkestone
              }, null, 8 /* PROPS */, ["settings", "terminal-data"]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["loading"]),
      _createVNode(DeparturesBoard, {
        terminal: _unref(Terminal).Uk
      }, null, 8 /* PROPS */, ["terminal"])
    ], 512 /* NEED_PATCH */), [
      [_vShow, activeTerminal.value == _unref(Terminal).Uk]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(LoadingWrapper, {
        loading: !mounted.value
      }, {
        default: _withCtx(() => [
          (_unref(travelInfoSettings)?.statusAlerts?.isVisible)
            ? (_openBlock(), _createBlock(StatusAlert, {
                key: 0,
                "status-alert": _unref(travelInfoSettings).statusAlerts.calais
              }, null, 8 /* PROPS */, ["status-alert"]))
            : _createCommentVNode("v-if", true),
          (
            _unref(travelInfoTerminals) && _unref(travelInfoSettings)?.latestInfo?.isVisible
          )
            ? (_openBlock(), _createBlock(TravelInfo, {
                key: 1,
                settings: _unref(travelInfoSettings),
                "terminal-data": _unref(travelInfoTerminals).calais
              }, null, 8 /* PROPS */, ["settings", "terminal-data"]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["loading"]),
      _createVNode(DeparturesBoard, {
        terminal: _unref(Terminal).Fr
      }, null, 8 /* PROPS */, ["terminal"])
    ], 512 /* NEED_PATCH */), [
      [_vShow, activeTerminal.value == _unref(Terminal).Fr]
    ])
  ]))
}
}

})